<template>
<div>
    <h3> 結果概要 </h3>
    <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
        <template slot="items" slot-scope="{ item: { score, selfs, category, meanScore, diffSelfAndmeanScore, sdScore, frequency}, index }">
            <tr>
                <td>{{category}}</td>
                <td>{{selfs}}</td>
                <td>{{meanScore}}</td>
                <td>{{diffSelfAndmeanScore}}</td>
                <td>{{sdScore}}</td>
            </tr>
        </template>
    </v-data-table>
</div>
</template>
<script>
import { mean, standardDeviation, max } from 'simple-statistics'
export default {
    components: {},
    props: {
        values: {
            required: true
        },
        ops:{
            required: true
        },
        categories:{
            required: true,
            type: Array
        }
    },
    data() {
        return {
            headers: [
                { text: '分類', value: 'category', sortable: false },
                { text: '本人平均', value: 'selfs' , sortable: false},
                { text: '協力者平均', value: 'meanScore' , sortable: false},
                { text: '協力者平均-本人', value: 'diffSelfAndmeanScore' , sortable: false},
                { text: '標準偏差', value: 'sdScore', sortable: false },
            ],
            numOfOptions: this.ops.length
        }
    },
    computed: {
        items() {
           return this.categories.map(c => {
               const v = this.values[c]
               const avg = this.round(mean(v.score), 2)
               const selfsAvg = this.round(mean(v.selfs), 2)
               return({
                category: v.category,
                selfs: selfsAvg,
                score: v.score,
                meanScore: avg,
                diffSelfAndmeanScore: this.round(avg - selfsAvg, 2),
                sdScore: this.round(standardDeviation(v.score),2),
                frequency: this.frequency(v.score),
            })}

            )
        }
    },
    methods: {
        frequency(score) {
            let dist = Array(this.numOfOptions).fill(0)
            score.forEach((e) => dist[e - 1] = dist[e - 1] + 1)
            return dist
        },
        round(value, demical){
            const n = Math.pow(10, demical)
            return (Math.round(value * n)/n).toFixed(demical)
        }

    }
}
</script>
